"use client"

import { useRouter } from "next/navigation"

const IndexPage = () => {
  const router = useRouter()
  router.replace("/home/")
  return null
}

export default IndexPage
